import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var scrollToNextSection = function scrollToNextSection() {
  var scrollSection = document.querySelector('.scroll-section');
  if (scrollSection) {
    window.scrollTo({
      top: scrollSection.offsetTop,
      behavior: 'smooth'
    });
  }
};
var showMobileMenu = function showMobileMenu(e) {
  e.preventDefault();
  e.currentTarget.classList.toggle('active');
  var navLinks = document.querySelector('.nav-links');
  if (navLinks) {
    navLinks.classList.toggle('active');
  }
};
var controlCaseStudySlide = function controlCaseStudySlide(e) {
  e.preventDefault();
  var slides = document.querySelectorAll('.case-study-slide');
  var activeSlide = document.querySelector('.case-study-slide.active');
  if (!activeSlide) return;
  var currentSlide = Array.from(slides).indexOf(activeSlide);
  var slideCount = slides.length - 1;
  var nextSlide = 0;
  var previousSlide = 0;

  // Seamless looping
  if (currentSlide === 0) {
    nextSlide = currentSlide + 1;
    previousSlide = slideCount;
  } else if (currentSlide === slideCount) {
    nextSlide = 0;
    previousSlide = currentSlide - 1;
  } else {
    nextSlide = currentSlide + 1;
    previousSlide = currentSlide - 1;
  }

  // Clear active class
  slides.forEach(function (slide) {
    return slide.classList.remove('active');
  });

  // Set next active slide based on button clicked
  if (e.currentTarget.classList.contains('next-slide-trigger')) {
    slides[nextSlide].classList.add('active');
  } else {
    slides[previousSlide].classList.add('active');
  }
};
var showNextStep = function showNextStep(e) {
  e.preventDefault();
  var processSteps = document.querySelectorAll('.process-step');
  var step = Array.from(processSteps).indexOf(e.currentTarget);
  var stepDescriptions = document.querySelectorAll('.step-description');
  var stepMediaImages = document.querySelectorAll('.step-media img');
  var stepDescription = stepDescriptions[step];
  var stepMedia = stepMediaImages[step];

  // Clear previous active steps
  processSteps.forEach(function (s) {
    return s.classList.remove('active');
  });
  stepDescriptions.forEach(function (d) {
    return d.classList.remove('active');
  });
  stepMediaImages.forEach(function (img) {
    return img.classList.remove('active');
  });

  // Set new active step
  e.currentTarget.classList.add('active');
  if (stepDescription) stepDescription.classList.add('active');
  if (stepMedia) stepMedia.classList.add('active');
};
var controlStepCarousel = function controlStepCarousel(e) {
  e.preventDefault();
  var stepDescriptions = document.querySelectorAll('.step-description');
  var activeDescription = document.querySelector('.step-description.active');
  if (!activeDescription) return;
  var currentStep = Array.from(stepDescriptions).indexOf(activeDescription);
  var stepCount = stepDescriptions.length - 1;
  var nextStep = 0;
  var previousStep = 0;

  // Seamless looping
  if (currentStep === 0) {
    nextStep = currentStep + 1;
    previousStep = stepCount;
  } else if (currentStep === stepCount) {
    nextStep = 0;
    previousStep = currentStep - 1;
  } else {
    nextStep = currentStep + 1;
    previousStep = currentStep - 1;
  }

  // Clear active classes
  var processSteps = document.querySelectorAll('.process-step');
  var stepMediaImages = document.querySelectorAll('.step-media img');
  processSteps.forEach(function (s) {
    return s.classList.remove('active');
  });
  stepDescriptions.forEach(function (d) {
    return d.classList.remove('active');
  });
  stepMediaImages.forEach(function (img) {
    return img.classList.remove('active');
  });

  // Set next active step based on button clicked
  var targetStep = e.currentTarget.classList.contains('next-step-trigger') ? nextStep : previousStep;
  if (processSteps[targetStep]) processSteps[targetStep].classList.add('active');
  if (stepDescriptions[targetStep]) stepDescriptions[targetStep].classList.add('active');
  if (stepMediaImages[targetStep]) stepMediaImages[targetStep].classList.add('active');
};
var saveAndShowNextCarousel = function saveAndShowNextCarousel() {
  document.querySelectorAll('.carousel-save').forEach(function (button) {
    button.addEventListener('click', function () {
      var formId = button.dataset.formId;
      var form = document.getElementById(formId);
      if (!form) return;
      var url = form.getAttribute('action');
      var formData = new FormData(form);

      // Clear previous errors
      document.querySelectorAll('.profile_error').forEach(function (error) {
        return error.remove();
      });
      fetch(url, {
        method: 'PUT',
        body: formData,
        headers: {
          'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
        }
      }).then(function (response) {
        return response.json();
      }).then(function () {
        // Move to next carousel item (Bootstrap carousel)
        var carousel = document.getElementById('consultant-profile-form');
        if (carousel && typeof bootstrap !== 'undefined') {
          var bsCarousel = bootstrap.Carousel.getInstance(carousel) || new bootstrap.Carousel(carousel);
          bsCarousel.next();
        }
        window.scrollTo(0, 0);
      })["catch"](function (error) {
        if (error.responseJSON) {
          var errorList = document.getElementById('error_list');
          if (errorList) {
            Object.entries(error.responseJSON).forEach(function (_ref) {
              var _ref2 = _slicedToArray(_ref, 2),
                value = _ref2[1];
              var li = document.createElement('li');
              li.className = 'profile_error';
              li.textContent = value;
              errorList.appendChild(li);
            });
          }
        }
      });
    });
  });
};
var finishConsultantProfile = function finishConsultantProfile() {
  document.querySelectorAll('.profile-finish').forEach(function (button) {
    button.addEventListener('click', function () {
      var formId = button.dataset.formId;
      var form = document.getElementById(formId);
      if (form) {
        form.submit();
      }
    });
  });
};
var setUpCandidateCards = function setUpCandidateCards() {
  if (window.innerWidth > 600) {
    var candidateTriggers = document.querySelectorAll('.candidate-trigger');
    candidateTriggers.forEach(function (trigger) {
      trigger.addEventListener('mouseenter', function () {
        document.querySelectorAll('.candidate-trigger img').forEach(function (img) {
          img.style.opacity = '0';
        });
        var img = trigger.querySelector('img');
        if (img) img.style.opacity = '1';
      });
      trigger.addEventListener('mouseleave', function () {
        var img = trigger.querySelector('img');
        if (img) img.style.opacity = '0';
      });
    });
  }
};
document.addEventListener('DOMContentLoaded', function () {
  // Set up process steps
  document.querySelectorAll('.process-step').forEach(function (step) {
    step.addEventListener('click', showNextStep);
  });
  document.querySelectorAll('.next-step-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', controlStepCarousel);
  });
  document.querySelectorAll('.previous-step-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', controlStepCarousel);
  });

  // Set up case study slides
  document.querySelectorAll('.next-slide-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', controlCaseStudySlide);
  });
  document.querySelectorAll('.previous-slide-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', controlCaseStudySlide);
  });

  // Set up scroll trigger
  document.querySelectorAll('.scroll-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', scrollToNextSection);
  });

  // Set up mobile navigation
  document.querySelectorAll('.mobile-menu-trigger').forEach(function (trigger) {
    trigger.addEventListener('click', showMobileMenu);
  });

  // Set up candidate cards
  setUpCandidateCards();

  // Set up carousel save
  saveAndShowNextCarousel();

  // Set up profile finish
  finishConsultantProfile();

  // Re-setup on window resize
  window.addEventListener('resize', function () {
    var secondCandidateImg = document.querySelector('.candidate-trigger:nth-child(2) img');
    if (secondCandidateImg) {
      secondCandidateImg.style.opacity = '1';
    }
    setUpCandidateCards();
  });
});